import gateway from '@interceptors/gateway.interceptor';

class TitleService {

    public getTitle = async (qrCodeId: string, cardInfoId: number ) => {
        const url = `/no-auth/card-info/get-title-by-qrCodeId-and-cardInfoId`;
        const responseDto = await gateway.get(url, { params: { qrCodeId, cardInfoId } });
        return responseDto?.data;
    }
    
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new TitleService();